import * as React from 'react';
import cx from 'classnames';
import { WordmarkLogo } from '@dropbox/dig-logos';
/**
 * A Logo component combined with an Anchor tag to allow for some
 * standardization around how a logo should function within the header.
 */
export const Logo = ({ href, src, renderAccessory, ...rest }) => (React.createElement("a", { ...rest, href: href, className: cx('dpc-GlobalHeader-Logo', {
        'dpc-GlobalHeader-Logo--hasAccessory': !!renderAccessory,
    }) },
    React.createElement(WordmarkLogo, { size: 32, src: src, role: "presentation" }),
    renderAccessory && renderAccessory));
Logo.displayName = 'Logo';
